var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "blue_status",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#40D0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStatus);
export default __webpack_public_path__ + "static/media/blue-status.41e1c1a3e6a8f78962c8a28b34bc304a.svg";
export { ForwardRef as ReactComponent };